(function () {
	function formatNumber(value) {
			return new Intl.NumberFormat('pt-BR').format(value)
		}
	
		function hydrateStoreReviews(root, summary) {
			var rating = Number(summary.aggregateRating || 0)
			var recommended = Math.round(Number(summary.recommendedPercentage || 0))
			var progress = Math.max(0, Math.min(100, recommended))
			var ratingText = rating.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 })
	
			root.querySelectorAll('[data-imune-rating]').forEach(function (item) { item.textContent = ratingText })
			root.querySelectorAll('[data-imune-count]').forEach(function (item) { item.textContent = formatNumber(Number(summary.reviewCount || 0)) })
			root.querySelectorAll('[data-imune-recommended]').forEach(function (item) { item.textContent = recommended + '%' })
			root.querySelectorAll('[data-imune-progress-rating]').forEach(function (item) { item.textContent = ratingText + '/5' })
			requestAnimationFrame(function () {
				root.querySelectorAll('[data-imune-progress]').forEach(function (bar) { bar.style.width = progress + '%' })
			})
		}
	
		function initStoreReviews(root) {
			root.querySelectorAll('[data-imune-reviews]').forEach(function (reviews) {
				if (reviews.dataset.imuneReady === 'true') return
				reviews.dataset.imuneReady = 'true'
				var url = reviews.dataset.apiUrl
				if (!url) return
	
				if (!window.__sterilairKonfidencySummaryPromise) {
					window.__sterilairKonfidencySummaryPromise = fetch(url)
						.then(function (response) {
							if (!response.ok) throw new Error('Konfidency request failed')
							return response.json()
						})
						.then(function (data) { return data.reviews.summary })
				}
	
				window.__sterilairKonfidencySummaryPromise
					.then(function (summary) { hydrateStoreReviews(reviews, summary) })
					.catch(function () { reviews.setAttribute('data-imune-error', 'true') })
			})
		}

	function boot(root) { initStoreReviews(root || document) }

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () { boot(document) })
	} else {
		boot(document)
	}

	document.addEventListener('shopify:section:load', function (event) { boot(event.target) })
})()
